import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.sass']
})
export class LoadingComponent implements OnInit {
  @Input() message: string;
  @Input() height: number;
  @Input() diameter = 32;

  constructor(
    private translate: TranslateService,
  ) {
    if (!this.message) {
      this.translate.get('shared.loading').pipe(take(1)).subscribe(translation => {
        this.message = translation;
      });
    }
  }

  ngOnInit() {
  }

}
